/**
 * Lowercase a string without throwing when CMS or API data is missing.
 */
export function safeToLowerCase(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value.toLowerCase() : fallback;
}
